//
// Copyright (c) 2021 Astute Global, Inc.
//

// @ts-ignore
import i18next from "i18n/i18n";
import { ButtonView, clickOutsideHandler, ContextualBalloon, Plugin } from "ckeditor5";

import conversationVariableIcon from "img/svg/add_variable.svg";
import ConversationVariableView from "./ui/conversationVariableView";

export default class ConversationVariableUi extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get requires() {
    return [ContextualBalloon];
  }

  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "ConversationVariableUi";
  }

  init() {
    this._addToolbarButton();
    this.balloon = this.editor.plugins.get(ContextualBalloon);
  }

  destroy() {
    super.destroy();
    if (this.conversationVariableView) {
      this.conversationVariableView.destroy();
      this.conversationVariableView = null;
    }
  }

  get _isConversationVariableViewInPanel() {
    return this.balloon.hasView(this.conversationVariableView);
  }

  _addConversationVariableView() {
    this.conversationVariableView = this._createConversationVariableView();
    const view = this.editor.editing.view;
    const viewDocument = view.document;
    this.conversationVariableView.disableCssTransitions();
    this.balloon.add({
      view: this.conversationVariableView,
      position: {
        target: () => {
          return view.domConverter.viewRangeToDom(viewDocument.selection.getFirstRange());
        },
      },
    });
    if (this.balloon.visibleView == this.conversationVariableView) {
      this.conversationVariableView.focus();
    }
    this.conversationVariableView.enableCssTransitions();
  }

  _addToolbarButton() {
    const editor = this.editor;
    editor.ui.componentFactory.add("conversationVariable", (locale) => {
      const command = editor.commands.get("conversationVariable");
      const button = new ButtonView(locale);
      button.set({
        isEnabled: true,
        label: i18next.t("ckeditor.conversationVariable.buttonName"),
        icon: conversationVariableIcon,
        tooltip: true,
      });
      button.bind("isEnabled").to(command);
      this.listenTo(button, "execute", () => this._showUi());
      return button;
    });
  }

  _cancelUi() {
    this.editor.commands.get("conversationVariable").refresh();
    this._closeConversationVariableView();
  }

  _closeConversationVariableView() {
    if (this._isConversationVariableViewInPanel) {
      this.balloon.remove(this.conversationVariableView);
      this.conversationVariableView.destroy();
      this.editor.editing.view.focus();
    }
  }

  _createConversationVariableView() {
    const editor = this.editor;
    const command = editor.commands.get("conversationVariable");
    const conversationVariableView = new ConversationVariableView(editor, command);
    conversationVariableView.on("submit", () => {
      editor.execute("conversationVariable", {
        insertType: this.conversationVariableView.insertType,
        variableId: this.conversationVariableView.variableId,
        variableName: this.conversationVariableView.variableName,
      });
      this._closeConversationVariableView();
    });
    conversationVariableView.on("cancel", () => {
      this._cancelUi();
    });
    clickOutsideHandler({
      emitter: conversationVariableView,
      activator: () => this._isConversationVariableViewInPanel,
      contextElements: [this.balloon.view.element],
      callback: () => this._cancelUi(),
    });
    return conversationVariableView;
  }

  _showUi() {
    this._addConversationVariableView();
    this.balloon.showStack("main");
  }
}
